import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Switch from '@material-ui/core/Switch';
import {
  getBrokeragesList,
  loadBrokerages,
  brokerageSelected
} from "../store/brokerages";
import Select from "react-dropdown-select";

const BrokerageSuperAdminUserData = () => {
  const dispatch = useDispatch();
  const [selectedCode, setSelectedCode] = useState(null);
  useEffect(() => {
    dispatch(loadBrokerages());
  }, [dispatch]);
  const onChangeHandle = (value) => {
    //dispatch(getDetailsAdmin(value[0].code));
    setSelectedCode(value[0].code);
  };
  const brokerages = useSelector(getBrokeragesList);
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
        }}
      >
        <div style={{ width: "80%", marginLeft: "10%", marginTop: "20px" }}>
          <Select
            placeholder={"Search for a brokerage"}
            color={theme.COLORS.primary_navyblue}
            searchable={true}
            onChange={(values) => onChangeHandle(values)}
            values={[]}
            options={brokerages}
            style={{
              width: "100%",
              height: "6vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
            }}
            labelField={"name"}
            valueField={"code"}
            dropdownHeight={"58vh"}
          />
        </div>
      </div>
      <UserDataPane></UserDataPane></div>
  );
};

const UserDataPane = () => {
  return (
    <div
      style={{
        margin: "3.5rem",
        marginTop: "1.5rem",
        marginBottom: "50vh",
      }}
    >
      <div>
        <h5 class="px-2" style={{
          fontFamily: "GibsonSemiBd",
          justifyContent: "center",
          fontSize: "1.2vw",
        }}>Quotey will make it super easy for you to extract your data.  This is just a placeholder while we build this functionality for you.</h5>
      </div>
    </div>
  );
};

export default BrokerageSuperAdminUserData;
